// extracted by mini-css-extract-plugin
export default {"inputGroup":"UploadFile_inputGroup__Uu+7R","fileUploadInput":"UploadFile_fileUploadInput__ItLYt","icon":"UploadFile_icon__Af5wQ","fileName":"UploadFile_fileName__e-gbn"};